import type { IconData } from '@stacksjs/iconify-core'

export const interfaceEssentialKeyboardButtonDirection1: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M22.86 9.14V0H9.15v9.14H0v13.72h9.15V32h13.71v-9.14H32V9.14Zm7.62 12.19h-9.14v9.15H10.67v-9.15H1.53V10.67h9.14V1.52h10.67v9.15h9.14Z\"/><path fill=\"currentColor\" d=\"M25.91 18.28h1.52v-1.52h1.52v-1.52h-1.52v-1.53h-1.52v-1.52h-1.53v7.62h1.53zm-7.62-1.52h1.52v1.52h-1.52Zm0-3.05h1.52v1.53h-1.52Zm-6.1 10.67v1.52h1.53v1.53h1.52v1.52h1.52v-1.52h1.53V25.9h1.52v-1.52zm6.1-19.81h-1.53V3.05h-1.52v1.52h-1.52v1.52h-1.53v1.53h7.62V6.09h-1.52zm-4.57 13.71h4.57v1.53h-4.57Zm-1.53-1.52h1.53v1.52h-1.53Zm0-3.05h1.53v1.53h-1.53Zm-6.09 0H4.57v1.53H3.05v1.52h1.52v1.52H6.1v1.53h1.52v-7.62H6.1z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default interfaceEssentialKeyboardButtonDirection1
